import React from 'react'
import './productDetail.css'
import ProductDetail from 'Components/ProductDetail'
import { t } from 'i18next'

export default function ProductDetailCustomer({
  product,
  isShow,
  handleCloseModal,
}) {
  return (
    <>
      <div className="container-detail-product">
        <h1 className="title-detail-product">
          {t('CUSTOMER_DISPLAY.TITLE_PRODUCT_DETAIL')}
        </h1>
        <div className="modal-product-detail">
          {product && (
            <ProductDetail
              id={product.ProductId}
              productsRef={null}
              producto_final={product}
              price={product.FinalPrice}
              cost={product.Cost || product.AvgCost || 0.0}
              openWithInventario={() => {}}
              handleClose={handleCloseModal}
              setShowMaterialsCalculatorPDP={false}
              setProductDetail={() => {}}
              isCustomerDisplay
            />
          )}
        </div>
      </div>
    </>
  )
}
